import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../_virtual/_rollupPluginBabelHelpers.js';
import styled from 'styled-components';

var _templateObject;
var SectionHeaderDefinition = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-content: center;\n  flex: 1;\n  flex-wrap: wrap;\n\n  @media (max-width: 767px) {\n    justify-content: center;\n  }\n"])));
SectionHeaderDefinition.displayName = "SectionHeader";

export { SectionHeaderDefinition as default };
